import { Injectable, InjectionToken, Inject } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { off } from 'process';
import { map } from 'rxjs/operators';
import { DwLoggingService, DwRoutingService, DwRoutingServiceToken, DwSecurityStateService } from '@devwareapps/devware-cap';

@Injectable({
    providedIn: 'root'
})
export class AviatorRouteGuardService implements CanActivate {

    constructor(
        @Inject(DwRoutingServiceToken) private routingService: DwRoutingService,
        private securityStateService: DwSecurityStateService,
        private logutil: DwLoggingService,
    ) {
        

     }

    canActivate(routeSnapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let route = routeSnapshot.routeConfig;

        if (route.path.indexOf("login") >= 0 || route.path.indexOf("register") >= 0) {
            if (this.securityStateService.securityState.isAuthenticated) {

                this.routingService.navigateToUrl("/", null);

                return false;
            }
        }

        return true;
    }
}